/* eslint-disable */
import { node } from "~/util/dom";
import { BRIEFCASE_OUTLINE_16, HOME_16, OVERFLOW_MENU_VERTICAL_FILLED_24, EDIT_FILLED_24, TRASH_FILLED_24 } from "@sznds/icons";
import createSDSIcon from "~/ui/icon";
import { createMarker } from "./marker";
import createMenu from "~/ui/homeworkitemmenu";
import { IItems, IItemData } from "./index";
import { _ } from "~/i18n";
import Scene from "~/scene";

interface ICallbacks {
	editCb?: (type:string) => void,
	deleteCb?: (type:string) => void,
	gotoCb?: (type:string) => void,
	menuCb?: (type:string, open:boolean) => void,
	highlightCb?: (type?:string, enter?:boolean) => void,
}

export class Item {
	#data: IItemData;
	#type: string;
	#cb: ICallbacks;
	#container: HTMLDivElement;
	#actionButton: HTMLButtonElement;
	#menuButton: HTMLButtonElement;
	#contextMenu: HTMLUListElement;
	#marker: any;

	constructor(type: string, data: IItems, callbacks: ICallbacks) {
		this.#data = data[type] || null;
		this.#type = type;
		this.#cb = callbacks;
		this.#container = node("div", { className: "item " + this.#type });

		this.#actionButton = null;
		this.#menuButton = null;
		this.#contextMenu = null;
		this.#marker = null;

		this.#container.addEventListener("click", this, false);
		this.#container.addEventListener("pointerenter", this, false);
		this.#container.addEventListener("pointerleave", this, false);

		this.#create();
	}

	destroy() {}

	get container() {
		return this.#container;
	}

	get marker() {
		return this.#marker;
	}

	set data(data: IItemData) {
		this.#data = data;

		this.#create();
	}

	handleEvent(event) {
		if (event.type === "click") {
			if (this.#container.classList.contains("menu-open") && this.#contextMenu != event.target && !this.#contextMenu.contains(event.target)) {
				this.closeMenu();
			}

			if (event.target === this.#actionButton) {
				if (this.#data?.mark) {
					this.#cb.gotoCb && this.#cb.gotoCb(this.#type);
				}
				else {
					this.#cb.editCb && this.#cb.editCb(this.#type);
				}
			}
			else if (this.#menuButton && (event.target === this.#menuButton || this.#menuButton.contains(event.target))) {
				event.stopPropagation();

				this.#container.classList.toggle("menu-open");
				window.document.addEventListener("click", this, false);
				window.document.addEventListener("keydown", this, false);
				this.#cb.menuCb && this.#cb.menuCb(this.#type, this.#container.classList.contains("menu-open"));
			}
		}
		else if (event.type === "pointerenter" || event.type === "pointerleave") {
			this.#cb.highlightCb(this.#type, event.type === "pointerenter");
		}
		else if (event.type === "keydown") {
			let keyCode = event.which || event.keyCode;

			if (keyCode == 27) {
				this.closeMenu();
			}
		}
	}

	isChange(data: IItemData): boolean {
		return !!(!data && this.#data) || !!(data && !this.#data) || !!(data && this.#data && data.id !== this.#data.id);
	}

	closeMenu() {
		this.#container.classList.remove("menu-open");
		window.document.removeEventListener("click", this, false);
		window.document.removeEventListener("keydown", this, false);
	}

	#create() {
		this.#container.innerHTML = "";
		const inner = node("div");

		const title = node("h4", {
			...this.#data?.title ? { title: this.#data.title } : {},
		}, this.#data?.title ? this.#data.title : _(`mymap.places.${this.#type}2`));

		title.firstChild.before(createSDSIcon({
			symbol: this.#type === "home" ? HOME_16 : BRIEFCASE_OUTLINE_16,
		}));

		const anchors = node("div", { className: "anchors" });
		this.#actionButton = node("button", { type: "button", className: !this.#data?.mark ? "set" : "", title: this.#data?.mark ? _("mymap.places.goToAddress.title") : _("mymap.places.set") }, this.#data?.mark ? _("mymap.places.goToAddress.title") : _("mymap.places.set"));
		anchors.append(this.#actionButton);

		inner.appendChild(title);
		inner.appendChild(anchors);

		this.#container.append(inner);

		if (this.#data?.mark) {
			this.#menuButton = node("button", { type: "button", title: _("mymap.places.options") });
			this.#menuButton.appendChild(createSDSIcon({
				symbol: OVERFLOW_MENU_VERTICAL_FILLED_24,
			}))
			this.#container.append(this.#menuButton);
		}

		if (this.#data?.mark) {
			if (this.#marker) {
				this.#marker.setCoords(Scene.coordsFromWGS84(this.#data.mark.lon, this.#data.mark.lat))
			}
			else {
				this.#createMarker();
			}

			this.#contextMenu = createMenu([
				{
					title: _("edit"),
					icon: EDIT_FILLED_24,
					cb: () => {
						this.#cb.editCb && this.#cb.editCb(this.#type);
					},
				},
				{
					title: _("delete"),
					icon: TRASH_FILLED_24,
					cb: () => {
						this.#cb.deleteCb && this.#cb.deleteCb(this.#type);
					},
				}
			]);

			this.#container.append(this.#contextMenu);
		}
		else if (this.#marker) {
			this.#marker.destroy();
			this.#marker = null;
		}

	}

	#createMarker() {
		this.#marker = createMarker(this.#type, this.#data.mark, {
			...this.#cb?.gotoCb ? { clickCb: this.#cb.gotoCb } : {},
			...this.#cb?.highlightCb ? {
				enterCb: () => { this.#cb?.highlightCb(this.#type, true); },
				leaveCb: () => { this.#cb?.highlightCb(this.#type, false); },
			} : {},
		});
	}
}
